export default "__VITE_ASSET__e7b43e55__"